import { render, staticRenderFns } from "./Identities.vue?vue&type=template&id=116a803e&scoped=true"
import script from "./Identities.vue?vue&type=script&lang=js"
export * from "./Identities.vue?vue&type=script&lang=js"
import style0 from "./Identities.vue?vue&type=style&index=0&id=116a803e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116a803e",
  null
  
)

export default component.exports